import categoriesByLocation from '../data/categoriesByLocation';
import data, { locale } from '../data';

import { applyLocationToData, applyViewPortToData } from './applyLocationToData';
import { getCountryViewport } from '../../../utils/geoLocation';

const getData = ({ locations, params }) => {
  const { filterSlug, locationSlug, sportSlug, localeSlug } = params;
  if (localeSlug && !locale.filter(l => !!l.slug).map(l => l.slug).includes(localeSlug)) {
    // Unsupported country code
    return undefined;
  }

  let sportData = data[sportSlug];
  if (!sportData) {
    // Unsupported sport type
    return undefined;
  }

  if (filterSlug) {
    sportData = sportData.filters[filterSlug];

    if (!sportData) {
      // Unsupported filter (e.g. distance)
      return undefined;
    }
  }

  if (locationSlug) {
    const supportedLocation = locations.find(
      l => l.slug === locationSlug && l.iso2.toLowerCase() === localeSlug,
    );
    const locationCategories = categoriesByLocation[locationSlug];
    const categorySlug = filterSlug ? `${sportSlug}-events/${filterSlug}` : `${sportSlug}-events`;
    if (!supportedLocation || !locationCategories || !locationCategories.includes(categorySlug)) {
      // Unsupported location
      return undefined;
    }
  }

  return sportData;
};

export default (props) => {
  const { locations, params: { locationSlug, localeSlug } } = props;

  let sportData = getData(props);

  if (sportData) {
    if (locationSlug) {
      const location = locations.find(l => l.slug === locationSlug);
      sportData = applyLocationToData(sportData, location);
    } else if (localeSlug) {
      const viewport = getCountryViewport(localeSlug);
      sportData = applyViewPortToData(sportData, viewport);
    }
  }

  return sportData;
};



// WEBPACK FOOTER //
// ./app/src/components/Discovery/helpers/getDataFromProps.js